import React, { useEffect, useState } from 'react';
import { ChatFilter, getChatFilterName } from '../../../models/ChatFilter';
import { useTextSearch } from '../../../hooks/useTextSearch';
import { InputSearch } from '../../../components/InputSearch';
import { Button, ButtonSize } from '../../../components/Button';
import { ButtonVariant } from '../../../config/colors';

interface ChatListViewHeaderProps {
  selectedFilter: ChatFilter;
  handleFilterChange: (filter: ChatFilter) => void;
}

export const ChatListViewHeader: React.FC<ChatListViewHeaderProps> = ({
  selectedFilter, 
  handleFilterChange
}) => {
  const { setTextSearch, setIsTextInputFocused } = useTextSearch();
  const [textSearchLocal, setTextSearchLocal] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setTextSearch(textSearchLocal);
    }, 500); 

    return () => clearTimeout(handler);
  }, [setTextSearch, textSearchLocal]);

  return (
    <div>
      <div className="px-4 pb-4">
        <InputSearch
          placeholder="Search"
          value={textSearchLocal}
          onClear={() => setTextSearchLocal('')}
          onChange={(e) => setTextSearchLocal(e.target.value)}
          onFocus={() => setIsTextInputFocused(true)}
          onBlur={() => setIsTextInputFocused(false)}
        />
      </div>

      <div className="px-4 pb-4">
        <div className="flex space-x-2 overflow-x-auto scrollbar-hide">
          {
            Object.values(ChatFilter).map((filter) => (
              <Button 
                  key={filter} 
                  variant={filter === selectedFilter ? ButtonVariant.inverted : ButtonVariant.unselected} 
                  size={ButtonSize.medium}
                  onClick={() => {
                    handleFilterChange(filter);
                  }}
                  className="flex-1"
              >
                  {getChatFilterName(filter)} 
              </Button>
            ))
          }
        </div>
      </div>
    </div>
  );
};